import { AlphaEBoxOutlineIcon } from './AlphaEBoxOutlineIcon';

/**
 * author: Contributors
 * id 6C02F23D-4684-4018-9E47-624103B0653E
 * name alpha-e-box-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-e-box-outline.svg
 * tags
 * - Alpha / Numeric 
 */
export const AlphabetEBoxOutlineIcon = AlphaEBoxOutlineIcon;
export default AlphabetEBoxOutlineIcon